"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var loading_bars_1 = require("../components/loading_bars");
var threeds1_container_1 = require("./threeds1_container");
var CheckoutThreeDS1Container = /** @class */ (function (_super) {
    tslib_1.__extends(CheckoutThreeDS1Container, _super);
    function CheckoutThreeDS1Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutThreeDS1Container.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "d-flex fx-justify-center mtb-1" },
                React.createElement(loading_bars_1.default, null)),
            React.createElement(threeds1_container_1.default, tslib_1.__assign({ show3ds1AlertBox: false }, this.props))));
    };
    return CheckoutThreeDS1Container;
}(React.Component));
exports.default = CheckoutThreeDS1Container;
//# sourceMappingURL=checkout_threeds1_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_threeds1_container.js
// module id = oT88
// module chunks = 20 21 22